var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"public_details"},[_c('div',{staticClass:"details_banner"}),_c('div',{staticClass:"width_1280 df_flex df_wrap details_content"},[_c('back-navbar',{staticClass:"back-navbar"},[_c('span',[_vm._v("返回")])]),_vm._t("left"),_vm._t("right")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }